import React from 'react';
import { Row, Col, Tooltip } from 'reactstrap';
import NestedTableQuoteItemColumn from './NestedTableQuoteItemColumn';

const QuoteItemNameWithValidation = ({ item, editRow }) => {
    const [stateIconHover, setStateIconHover] = React.useState(false);
    const [stateNotesHover, setStateNotesHover] = React.useState(false);

    const errors = item.validationErrors.filter(err => err.severity === "error")
    const warnings = item.validationErrors.filter(err => err.severity === "warning")

    const isInvalid = errors.length > 0 || warnings.length > 0;
    const iconClassName = errors.length > 0 ? "bi-x-circle text-danger mx-2" : warnings.length > 0 ? "bi-exclamation-triangle text-warning mx-2" : "bi-square mx-2" // This case won't be used since we hide the icon when all are valid

    return (
        <Row className="g-0 flex-nowrap align-items-center w-100">
            <Col xs="auto">
                <i 
                    id={`error${item.id}`} style={{ visibility: isInvalid ? 'visible' : 'hidden' }} className={`bi ${iconClassName}`}
                    onMouseEnter={() => setStateIconHover(true)}
                    onMouseLeave={() => setStateIconHover(false)}
                ></i>
                {stateIconHover && <Tooltip
                        placement="top"
                        target={`error${item.id}`}
                        className="align-left"
                        innerClassName='tooltip-inner-custom'
                        isOpen={true}
                    >
                        {errors.length > 0 && (<div>
                            <strong>Errors:</strong>
                            <ul>
                                {errors.map(x =>
                                    <li key={x.id}>
                                        {x.error}
                                        {x.detail && <div className="text-muted px-4" dangerouslySetInnerHTML={{ __html: x.detail }}></div>}
                                    </li>
                                )}
                            </ul>
                        </div>
                        )}
                        {warnings.length > 0 && (<div className={errors.length > 0 ? "mt-4" : ""}>
                            <strong>Warnings:</strong>
                            <ul>
                                {warnings.map(x =>
                                    <li key={x.id}>
                                        {x.error}
                                        {x.detail && <div className="text-muted px-4" dangerouslySetInnerHTML={{ __html: x.detail }}></div>}
                                    </li>
                                )}
                            </ul>
                        </div>
                        )}

                        {/* Inline styles for the tooltip body */}
                        <style>
                            {`
                            .tooltip-inner-custom {
                                max-width: 600px !important;
                                background-color: #dc3545 !important;
                                color: rgba(234, 242, 251, 0.78);
                                border: 1px solid #dc3545 !important;
                                padding: 0.5rem;
                                font-weight: 500;
                                text-align: left;
                                white-space: normal; /* allow wrapping */
                            }
                        `}
                        </style>
                    </Tooltip>
                }
            </Col>
            <Col>
                {editRow ? (
                    <NestedTableQuoteItemColumn 
                        row={item}
                        columnKey={"internalName"}
                        onChange={(e) => editRow(item, "internalName", e.target.value)}
                    />
                ) : (
                    item.internalName
                )}
            </Col>
            {item.notes !== null && item.notes !== "" &&
                <Col xs="auto">
                    <i className="bi bi-file-earmark-fill p-1" id={'Tooltip-' + item.id}
                        onMouseEnter={() => setStateNotesHover(true)}
                        onMouseLeave={() => setStateNotesHover(false)}
                    ></i>
                    {stateNotesHover && <Tooltip
                            placement="top"
                            target={'Tooltip-' + item.id}
                            isOpen={true}
                        >
                            {item.notes}
                        </Tooltip>
                    }
                </Col>
            }
        </Row>
    );
};

export default QuoteItemNameWithValidation;
